
import { defineComponent } from 'vue';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'Banner',
  props: {
    type: {
      type: Number,
    },
  },
  data() {
    return {
      title: '',
      image: '',
      url: '',
      width: 0,
      height: 0,
    };
  },
  created() {
    if (!config.OBJECTS) return;

    let item = null;

    if (this.type === 1) {
      item = this.pickRandom(config.OBJECTS.filter((x) => x.image1).map((x) => ({ title: x.title, url: x.url, image: x.image1 })));
      this.width = 1300;
      this.height = 200;
    } else if (this.type === 2) {
      item = this.pickRandom(config.OBJECTS.filter((x) => x.image2).map((x) => ({ title: x.title, url: x.url, image: x.image2 })));
      this.width = 1100;
      this.height = 270;
    } else if (this.type === 3) {
      item = this.pickRandom(config.OBJECTS.filter((x) => x.image3).map((x) => ({ title: x.title, url: x.url, image: x.image3 })));
      this.width = 360;
      this.height = 360;
    }

    if (item) {
      this.title = item.title;
      this.url = item.url;
      this.image = item.image;
    }
  },
  methods: {
    pickRandom(array) {
      const random = Math.floor(Math.random() * array.length);
      return array[random];
    },
  },
});
